import {
  SexualOrientationActionTypes,
  SEXUALORIENTATION_LIST_FAIL,
  SEXUALORIENTATION_LIST_LOADING,
  SEXUALORIENTATION_LIST_SUCCESS,
  SexualOrientationState,
  SEXUALORIENTATION_LIST_API_MSG,
  SEXUALORIENTATION_LIST_API_RES,
} from "./ActionTypes";
import { SexualOrientationResponse } from "./Model";

const initialStateEditPosts: SexualOrientationState = {
  loading: false,
  sexualOrientationResponse: {} as SexualOrientationResponse,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const sexualOrientationListReducer = (
  state = initialStateEditPosts,
  action: SexualOrientationActionTypes
): SexualOrientationState => {
  switch (action.type) {
    case SEXUALORIENTATION_LIST_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case SEXUALORIENTATION_LIST_SUCCESS:
      return {
        ...state,
        sexualOrientationResponse: action.payload,
        successMsg: action.successMsg,
      };
    case SEXUALORIENTATION_LIST_FAIL:
      return {
        ...state,
        sexualOrientationResponse: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case SEXUALORIENTATION_LIST_API_MSG:
      return {
        ...state,
        sexualOrientationResponse: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case SEXUALORIENTATION_LIST_API_RES:
      return {
        ...state,
        sexualOrientationResponse: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};
